<!--
	@name app-events
	@description events page
	@date 2022/09/30
	@license no license
	@copywrite Answers In Retirement Limited
-->

<template>
	<div :component="$options.name">
		<v-container class="py-0 px-4" style="max-width: 800px">
			<app-events-event-details v-if="event" :event="event" :breadcrumbs="breadcrumbs" />
		</v-container>
	</div>
</template>
Ï
<script>
	import { mapActions, mapState } from 'vuex';
	import AppEventsEventDetails from '@/component/app/events/event-details';

	export default {
		name: 'app-events-event',

		components: {
			AppEventsEventDetails
		},

        data() {
			return {
				breadcrumbs: [{
					text: `Back to events`,
					disabled: false,
					exact: true,
					to: `/events`
				}]
			};
		},

		computed: {
			...mapState('CmsEvent', ['event'])
        },

		created() {
            this.getEvent(this.$route.params.id).then(() => {
				this.$nextTick(() => {
					this.breadcrumbs.push({
						text: this.event.name,
						disabled: true
					});
				});
            });
        },

		destroyed() {
			this.clearEvent();
		},

		methods: {
            ...mapActions('CmsEvent', ['getEvent', 'clearEvent'])
		}
	};
</script>
